<li class="text-left yyy" href="#" >
  <a  routerLink="/webshop/favorieten" [hidden]="NotLogged">
    <i class="icon-sli-star text-white"></i>
    <span class="hide-s hide-m"><span class="disflip"> {{translate('Favorieten')}}</span> [{{AantalItems}}]</span>
  </a>
</li>